export const pointOf = (touch)=>({
        x: touch.clientX,
        y: touch.clientY
    });
// WHY: a swipe must be clearly sideways and long enough, or a thumb scrolling the page would count as one.
const MIN_SWIPE_DISTANCE = 40;
const SIDEWAYS_DOMINANCE = 1.5;
export const swipeDirectionOf = (start, end)=>{
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const isSwipe = Math.abs(dx) >= MIN_SWIPE_DISTANCE && Math.abs(dx) > Math.abs(dy) * SIDEWAYS_DOMINANCE;
    if (!isSwipe) return null;
    return dx < 0 ? 'left' : 'right';
};
